import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "my-6" }
const _hoisted_2 = {
  key: 0,
  class: "a4"
}
const _hoisted_3 = { style: {"position":"relative"} }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onUpdate:modelValue", "onInput", "onPaste"]
const _hoisted_8 = ["onUpdate:modelValue", "onInput"]
const _hoisted_9 = {
  class: "char-count",
  style: {"position":"absolute","bottom":"0px","right":"-30px","z-index":"3","background-color":"white","padding":"2px 5px","font-size":"8px"}
}
const _hoisted_10 = {
  key: 1,
  class: "a4-landscape"
}
const _hoisted_11 = { style: {"position":"relative"} }
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["onUpdate:modelValue", "onInput", "onPaste"]
const _hoisted_16 = ["onUpdate:modelValue", "onInput"]
const _hoisted_17 = {
  class: "char-count",
  style: {"position":"absolute","bottom":"0px","right":"-40px","z-index":"3","background-color":"white","padding":"2px 5px","font-size":"8px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[12] || (_cache[12] = _createElementVNode("h3", null, "Edit Newsletter", -1)),
    _createVNode(_component_v_card, {
      variant: "outlined",
      class: "mt-6 pa-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.letterInput.date,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.letterInput.date) = $event)),
                      label: "Issue Date*",
                      type: "date",
                      density: "compact",
                      "hide-details": "",
                      variant: "outlined"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      label: "Created By*",
                      modelValue: _ctx.letterInput.createdBy,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.letterInput.createdBy) = $event)),
                      density: "compact",
                      "hide-details": "",
                      variant: "outlined"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.letterInput.className,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.letterInput.className) = $event)),
                      label: "Class Name",
                      density: "compact",
                      "hide-details": "",
                      variant: "outlined"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.category == 'healthLetter')
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.letterInput.name,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.letterInput.name) = $event)),
                          label: "Newsletter Name*",
                          density: "compact",
                          "hide-details": "",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          items: _ctx.metaTitleTypeItems,
                          modelValue: _ctx.healthLetterBody[0].meta.titleType,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.healthLetterBody[0].meta.titleType) = $event)),
                          label: "Title Type",
                          density: "compact",
                          "hide-details": "",
                          variant: "outlined",
                          "item-title": "text",
                          "item-value": "value"
                        }, null, 8, ["items", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          items: _ctx.metaTitleItems,
                          modelValue: _ctx.healthLetterBody[0].meta.titleFontSize,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.healthLetterBody[0].meta.titleFontSize) = $event)),
                          label: "Font Size",
                          density: "compact",
                          "hide-details": "",
                          variant: "outlined",
                          "item-title": "text",
                          "item-value": "value"
                        }, null, 8, ["items", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.letterInput.name,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.letterInput.name) = $event)),
                          label: "Newsletter Name*",
                          density: "compact",
                          "hide-details": "",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          items: _ctx.metaTitleTypeItems,
                          modelValue: _ctx.nurseryLetterBody[0].meta.titleType,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.nurseryLetterBody[0].meta.titleType) = $event)),
                          label: "Title Type",
                          density: "compact",
                          "hide-details": "",
                          variant: "outlined",
                          "item-title": "text",
                          "item-value": "value"
                        }, null, 8, ["items", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          items: _ctx.metaTitleItems,
                          modelValue: _ctx.nurseryLetterBody[0].meta.titleFontSize,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.nurseryLetterBody[0].meta.titleFontSize) = $event)),
                          label: "Font Size",
                          density: "compact",
                          "hide-details": "",
                          variant: "outlined",
                          "item-title": "text",
                          "item-value": "value"
                        }, null, 8, ["items", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _cache[13] || (_cache[13] = _createElementVNode("div", { style: {"font-size":"18px","color":"#dc143c","margin-top":"8px"} }, " * Please enter text to fit within the frame. ", -1)),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          align: "center",
          justify: "center"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_v_progress_circular, {
              color: "primary",
              indeterminate: "",
              size: 150
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("Processing...", -1)
              ]))]),
              _: 1
            }, 512), [
              [_vShow, _ctx.loading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (_ctx.category == 'healthLetter')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: _ctx.url,
                style: {"width":"100%"}
              }, null, 8, _hoisted_4),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.healthLetterBody, (item, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  (item.meta && item.meta.titleType == 'none')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                    : (item.meta && item.meta.titleType == 'text')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          style: _normalizeStyle(item.style)
                        }, [
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": ($event: any) => ((item.title.text) = $event),
                            style: _normalizeStyle(item.title.style + item.meta.titleFontSize),
                            class: "input-bg"
                          }, null, 12, _hoisted_6), [
                            [_vModelText, item.title.text]
                          ])
                        ], 4))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          style: _normalizeStyle(item.style)
                        }, [
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": ($event: any) => ((item.title.text) = $event),
                            onInput: ($event: any) => (_ctx.limitHealthTitleLength($event, item.title)),
                            onPaste: ($event: any) => (_ctx.healthlimitLines($event, item.title)),
                            style: _normalizeStyle(item.title.style),
                            class: "input-bg"
                          }, null, 44, _hoisted_7), [
                            [_vModelText, item.title.text]
                          ]),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": ($event: any) => ((item.body.text) = $event),
                            onInput: ($event: any) => (_ctx.limitTextLength($event, item.body, item.maxLength)),
                            style: _normalizeStyle(item.body.style),
                            class: "input-bg"
                          }, null, 44, _hoisted_8), [
                            [_vModelText, item.body.text]
                          ]),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(item.body.text.length) + " / " + _toDisplayString(item.maxLength), 1)
                        ], 4))
                ]))
              }), 128))
            ])
          ]))
        : (_ctx.category == 'nurseryLetter')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("img", {
                  src: _ctx.url,
                  style: {"width":"100%"}
                }, null, 8, _hoisted_12),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nurseryLetterBody, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    (item.meta && item.meta.titleType == 'none')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                      : (item.meta && item.meta.titleType == 'text')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: _normalizeStyle(item.style)
                          }, [
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((item.title.text) = $event),
                              style: _normalizeStyle(item.title.style + item.meta.titleFontSize),
                              class: "input-bg"
                            }, null, 12, _hoisted_14), [
                              [_vModelText, item.title.text]
                            ])
                          ], 4))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            style: _normalizeStyle(item.style)
                          }, [
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((item.title.text) = $event),
                              onInput: ($event: any) => (_ctx.limitTitleLength($event, item.title)),
                              onPaste: ($event: any) => (_ctx.limitLines($event, item.title)),
                              style: _normalizeStyle(item.title.style),
                              class: "input-bg"
                            }, null, 44, _hoisted_15), [
                              [_vModelText, item.title.text]
                            ]),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((item.body.text) = $event),
                              onInput: ($event: any) => (_ctx.limitTextLength($event, item.body, item.maxLength)),
                              style: _normalizeStyle(item.body.style),
                              class: "input-bg"
                            }, null, 44, _hoisted_16), [
                              [_vModelText, item.body.text]
                            ]),
                            _createElementVNode("div", _hoisted_17, _toDisplayString(item.body.text.length) + " / " + _toDisplayString(item.maxLength), 1)
                          ], 4))
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !_ctx.loading]
    ]),
    _createVNode(_component_v_container, { class: "mt-6" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          align: "center",
          justify: "center"
        }, {
          default: _withCtx(() => [
            (_ctx.isUpdate)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.updateLetter,
                      loading: _ctx.loading,
                      color: "primary",
                      variant: "flat",
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isUpdate)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.exportLetter,
                      loading: _ctx.loading,
                      color: "primary",
                      variant: "flat",
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode("mdi-tray-arrow-down", -1)
                          ]))]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.download')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_col, {
                  key: 2,
                  cols: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.createLetter,
                      loading: _ctx.loading,
                      color: "primary",
                      variant: "flat",
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.create')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                })),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_menu, { location: "bottom" }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps({
                      color: "primary",
                      class: "mx-4",
                      loading: _ctx.loading,
                      variant: "outlined",
                      block: ""
                    }, props), {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode(" Overwrite with Template ", -1)
                      ]))]),
                      _: 1
                    }, 16, ["loading"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                          return _createVNode(_component_v_list_item, {
                            onClick: ($event: any) => (_ctx.setTemplateValues(i)),
                            key: i
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(`Month ${i}`), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        }), 64))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}